export default __webpack_public_path__ + "static/media/kitten1M.15017f33.webp";